(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-order-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-multi-size-order')) {
    class CustomMultiSizeOrder extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add-multi-size]');
        this.status = this.querySelector('[data-multi-size-status]');
        this.button.addEventListener('click', () => this.addSelectedSizes());
      }

      async addSelectedSizes() {
        const form = this.closest('form');
        if (!form.reportValidity()) return;

        const selections = Array.from(this.querySelectorAll('[data-multi-size-quantity]'))
          .map((input) => ({
            id: input.dataset.variantId,
            quantity: Number.parseInt(input.value, 10) || 0,
          }))
          .filter((item) => item.quantity > 0);

        if (selections.length === 0) {
          this.status.textContent = this.dataset.selectError;
          return;
        }

        const propertyFields = Array.from(form.elements).filter(
          (field) => field.name && field.name.startsWith('properties[')
        );
        const designGroup = `MULTI-${Date.now()}`;

        this.button.disabled = true;
        this.status.textContent = this.dataset.addingMessage;

        try {
          for (const selection of selections) {
            const itemData = new FormData();
            itemData.append('id', selection.id);
            itemData.append('quantity', selection.quantity);

            for (const field of propertyFields) {
              if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
              if (field.type === 'file') {
                if (field.files && field.files[0]) itemData.append(field.name, field.files[0]);
              } else if (field.value) {
                itemData.append(field.name, field.value);
              }
            }

            itemData.append(`properties[${this.dataset.orderTypeProperty}]`, this.dataset.orderTypeValue);
            itemData.append('properties[_Design group]', designGroup);

            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: itemData,
            });

            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || error.message);
            }
          }

          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = `${this.dataset.errorPrefix} ${error.message}`;
          this.button.disabled = false;
        }
      }
    }

    customElements.define('custom-multi-size-order', CustomMultiSizeOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-order-flow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-order-flow')) {
    class CustomOrderFlow extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;

        this.partyPackageVariantId = this.dataset.partyPackageVariantId;
        this.partyChoiceFields = Array.from(this.querySelectorAll('[data-party-package-choice]'));

        this.form.addEventListener('change', () => this.updatePartyPackageRequirements());
        this.form.addEventListener('submit', (event) => {
          this.updatePartyPackageRequirements();
          if (!this.form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);

        this.updatePartyPackageRequirements();

        if (this.dataset.isShirtOrder !== 'true') return;

        this.tabs = Array.from(this.querySelectorAll('[data-order-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-order-panel]'));
        this.buttonsContainer = this.form.querySelector('.product-form__buttons');
        this.submitLabel = this.buttonsContainer?.querySelector('[name="add"] span');

        for (const tab of this.tabs) {
          tab.addEventListener('click', () => this.selectTab(tab.dataset.orderTab));
          tab.addEventListener('keydown', (event) => this.handleTabKeys(event));
        }

        this.selectTab('existing');
      }

      updatePartyPackageRequirements() {
        if (!this.partyPackageVariantId || this.partyChoiceFields.length === 0) return;
        const variantInput = this.form.querySelector('.product-variant-id');
        const packageSelected = variantInput?.value === this.partyPackageVariantId;
        for (const field of this.partyChoiceFields) field.required = packageSelected;
      }

      selectTab(mode) {
        for (const tab of this.tabs) {
          const isActive = tab.dataset.orderTab === mode;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        }

        for (const panel of this.panels) {
          const isActive = panel.dataset.orderPanel === mode;
          panel.hidden = !isActive;
          for (const field of panel.querySelectorAll('input, textarea, select')) {
            field.disabled = !isActive;
          }
        }

        if (this.buttonsContainer) this.buttonsContainer.hidden = mode !== 'existing';
        if (this.submitLabel && mode === 'existing') this.submitLabel.textContent = this.dataset.shirtButtonLabel;
      }

      handleTabKeys(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        const nextIndex = event.key === 'ArrowRight'
          ? (currentIndex + 1) % this.tabs.length
          : (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        this.tabs[nextIndex].focus();
        this.selectTab(this.tabs[nextIndex].dataset.orderTab);
      }
    }

    customElements.define('custom-order-flow', CustomOrderFlow);
  }

  if (!customElements.get('custom-multi-size-order')) {
    class CustomMultiSizeOrder extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add-multi-size]');
        this.status = this.querySelector('[data-multi-size-status]');
        this.button.addEventListener('click', () => this.addSelectedSizes());
      }

      async addSelectedSizes() {
        const form = this.closest('form');
        if (!form.reportValidity()) return;

        const selections = Array.from(this.querySelectorAll('[data-multi-size-quantity]'))
          .map((input) => ({
            id: input.dataset.variantId,
            quantity: Number.parseInt(input.value, 10) || 0,
          }))
          .filter((item) => item.quantity > 0);

        if (selections.length === 0) {
          this.status.textContent = this.dataset.selectError;
          return;
        }

        const propertyFields = Array.from(form.elements).filter(
          (field) => field.name && field.name.startsWith('properties[')
        );
        const designGroup = `MULTI-${Date.now()}`;

        this.button.disabled = true;
        this.status.textContent = this.dataset.addingMessage;

        try {
          for (const selection of selections) {
            const itemData = new FormData();
            itemData.append('id', selection.id);
            itemData.append('quantity', selection.quantity);

            for (const field of propertyFields) {
              if (field.disabled) continue;
              if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
              if (field.type === 'file') {
                if (field.files && field.files[0]) itemData.append(field.name, field.files[0]);
              } else if (field.value) {
                itemData.append(field.name, field.value);
              }
            }

            itemData.append(`properties[${this.dataset.orderTypeProperty}]`, this.dataset.orderTypeValue);
            itemData.append('properties[_Design group]', designGroup);

            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: itemData,
            });

            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || error.message);
            }
          }

          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = `${this.dataset.errorPrefix} ${error.message}`;
          this.button.disabled = false;
        }
      }
    }

    customElements.define('custom-multi-size-order', CustomMultiSizeOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shirt-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-shirt-gallery')) {
    class CustomShirtGallery extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-gallery-filter]'));
        this.items = Array.from(this.querySelectorAll('[data-gallery-item]'));

        for (const button of this.buttons) {
          button.addEventListener('click', () => this.filter(button.dataset.galleryFilter));
        }
      }

      filter(category) {
        for (const button of this.buttons) {
          const isActive = button.dataset.galleryFilter === category;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        }

        for (const item of this.items) {
          item.hidden = category !== 'all' && item.dataset.category !== category;
        }
      }
    }

    customElements.define('custom-shirt-gallery', CustomShirtGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
